module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/juc/juc.component.html
// module id = ./src/app/juc/juc.component.html
// module chunks = main